const PERMISSION_KEY= "crm:popup_user";
const PAGE_URL = {
    POPUP_USER_PAGE: "/admin/crm/popup-user"
}

export {PERMISSION_KEY, PAGE_URL}

